import evaluateStageChange from 'actions/configuration/evaluateStageChange';
import configurationSelectors from 'selectors/configuration';
import { isAppInitialized, getIsMinimized } from 'app/modules';
import hideDefaultAndCustomWidget from 'actions/ui/hideDefaultAndCustomWidget';
import uiEnums from 'enums/ui';

export default function evaluateStage(dispatch, getState) {
  const state = getState();

  // if kill switch is enabled, don't change any stages. Widget will be hidden by default.
  if (configurationSelectors.getKillswitchIsOn(state.configuration)) {
    return;
  }

  // if app is not fully initialized, do not evaluate rules
  if (!isAppInitialized(state)) {
    return;
  }

  const newStage = dispatch(evaluateStageChange);

  if (newStage === uiEnums.STAGES.CHAT_CLOSED || newStage === uiEnums.STAGES.CHAT_THROTTLED) {
    if (getIsMinimized(state)) {
      dispatch(hideDefaultAndCustomWidget);
    }
  }
}
